import React from 'react';
import { Card, Spacer, Stencil } from '@cleartrip/bento';
import { Divider } from '@cleartrip/bento/components/Divider';

function SummaryLoading() {
	return (
		<>
			<Card className='br-4 bc-neutral-100 ba p-4 flex flex-middle d-none--xs'>
				<Stencil height={72} width={72} className='br-100' />
				<Spacer className='mr-4' />
				<div className='flex flex-column flex-wrap o-hidden'>
					<Stencil shimmer height={16} width={304} />
					<Spacer className='pt-2' />
					<Stencil shimmer height={16} width={700} />
					<Spacer className='pt-3' />
					<Stencil shimmer height={16} width={408} />
					<Spacer className='pt-4' />
					<div className='flex flex-between'>
						<Stencil shimmer height={16} width={60} />
						<Stencil shimmer height={16} width={150} />
					</div>
				</div>
			</Card>

			<Card className='br-4 bc-neutral-100 ba d-block--xs d-none'>
				<div className='py-3 px-4 flex flex-middle'>
					<Stencil height={28} width={28} className='br-100' />
					<Spacer className='mr-4' />
					<div className="flex-1">
						<Stencil shimmer height={12} width={'100%'} />
						<Spacer className='pt-2' />
						<Stencil shimmer height={12} width={'50%'} />
					</div>
				</div>
				<Divider className="bc-neutral-0" />
				<div className='py-3 px-4'>
					<Stencil shimmer height={12} width={'80%'} />
					<Spacer className='pt-2' />
					<Stencil shimmer height={12} width={'70%'} />
					<Spacer className='pt-2' />
					<Stencil shimmer height={12} width={'50%'} />
					<Spacer className="pt-4" />
					<div className='flex flex-between'>
						<Stencil shimmer height={16} width={100} />
						<Stencil shimmer height={16} width={120} />
					</div>
				</div>
			</Card>
		</>
	);
}

export default SummaryLoading;
